import { useRef, useState } from 'preact/hooks'

import { getPBProps } from '@content/helpers/src/utils'
import Placeholder from '@components/media-text/components/placeholder/Placeholder'
import { PbPropsProvider } from '@content/helpers/src/context'
import { ProductsProvider } from '@content/helpers/src/contextProducts'
import { MediaTextPBProps } from './types'
import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker'
import styles from './MediaText.module.scss'
import { ModalProvider } from '@commons/enhanced-modal/ModalContext'
import ModalRenderer from '@commons/enhanced-modal/ModalRenderer.tsx'
import { getTestId } from '@content/helpers/src/utils'
import { CampaignProps, LayoutProps } from '@commons/types'
import { forwardRef } from 'preact/compat'

type MediaTextProps = {
    readonly data: string
}

export type MediaTextComponentProps = {
    campaign?: CampaignProps
    layout: LayoutProps
    layoutPadding: string[]
    selectedCategory?: string
    className?: string
    backgroundClass?: string
}

export const MediaTextComponent = forwardRef<
    HTMLDivElement,
    MediaTextComponentProps
>(
    (
        {
            campaign,
            layout,
            layoutPadding,
            selectedCategory,
            className,
            backgroundClass
        },
        ref
    ) => {
        const [selectedPromotionDetails, setSelectedPromotionDetails] =
            useState(null)
        return (
            <ProductsProvider>
                <ModalProvider>
                    <ModalRenderer
                        promotion_details={selectedPromotionDetails}
                        campaign={campaign}
                    />
                    <div className={backgroundClass} ref={ref}>
                        <section
                            className={`${!className ? styles.default : className} ${styles['nb-media-text']} ${styles[`media-text--is-position-${layout.align}`]} ${layout.align_mobile === 'bottom' ? styles['media-text--is-position-bottom-mobile'] : ''}  ${[...layoutPadding].join(' ')} ${styles[`contrast-${layout.contrast}`]} `}
                            data-testid={getTestId('media-text')}>
                            <Placeholder
                                selectedCategory={selectedCategory}
                                setSelectedPromotionDetails={
                                    setSelectedPromotionDetails
                                }
                            />
                        </section>
                    </div>
                </ModalProvider>
            </ProductsProvider>
        )
    }
)
const MediaText = ({ data }: MediaTextProps) => {
    const pbProps = getPBProps<MediaTextPBProps>(data)
    const { campaign, layout } = pbProps
    const layoutPadding = [layout.padding_top, layout.padding_bottom]
    const { background_color } = layout
    const containerRef = useRef(null)

    const backgroundClassMap = {
        subtle_highlight: styles['background-default-highlight'],
        highlight_040: styles['background-highlight']
    }

    const backgroundClass =
        backgroundClassMap[background_color] ||
        (background_color ? styles[`background-${background_color}`] : '')

    useImpressionTracker(containerRef, campaign)

    return (
        <PbPropsProvider value={pbProps}>
            <MediaTextComponent
                ref={containerRef}
                layout={layout}
                layoutPadding={layoutPadding}
                campaign={campaign}
                backgroundClass={backgroundClass}
            />
        </PbPropsProvider>
    )
}

export default MediaText
